export default "__VITE_ASSET__BvLdj81W__"